module.exports = __webpack_public_path__ + "img/qy_03.png";